import { createRoute } from '@tanstack/react-router';
import { appRoute } from '@/features/dashboard/_root/routes/appRoute.tsx';
import PromoCodesPage from '@/features/dashboard/discounts/pages/PromoCodesPage.tsx';

export const promoCodesRoute = createRoute({
  getParentRoute: () => appRoute,
  path: '/promo-codes',
  component: PromoCodesPage,
});
